export var SnoozeFilterType;
(function (SnoozeFilterType) {
    SnoozeFilterType[SnoozeFilterType["ONLY"] = 1] = "ONLY";
    SnoozeFilterType[SnoozeFilterType["INCLUDE"] = 2] = "INCLUDE";
    SnoozeFilterType[SnoozeFilterType["EXCLUDE"] = 3] = "EXCLUDE";
})(SnoozeFilterType || (SnoozeFilterType = {}));
//# sourceMappingURL=snooze-filters.i.js.map